import { render, staticRenderFns } from "./header.vue?vue&type=template&id=48d22c18&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/willin/Documents/shiwangme/shiwangme_new_cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('48d22c18', component.options)
    } else {
      api.reload('48d22c18', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=48d22c18&", function () {
      api.rerender('48d22c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "client/views/header.vue"
export default component.exports